
import {
	LAMBDA_CONFIG_CONTRIBUYENTE
	, LAMBDA_CONFIG_EMISION
	, LAMBDA_PING
	, PLATAFORMA
} from '@/config'
import LambdaInvoke from '@/library/utils/LambdaInvoke';
import { API, Auth } from 'aws-amplify';

export async function apiGetConfigPorContribuyente(){

	const username='test',
		contribuyente=17978345;

	try{
		
		const payload = {contribuyente, username};
		let body = await LambdaInvoke(LAMBDA_CONFIG_CONTRIBUYENTE, payload);
		return body;
	}catch(err){
		console.error(err)
		throw err;
	}
}

export async function apiGetEboletaConfig(){
	let resp = await API.get('apiConfiguracion', '/eboleta/configuraciones')
	
	return resp;
}

export async function apiGetEboletaConfigEmision(){
	let resp = await LambdaInvoke(LAMBDA_CONFIG_EMISION);
	return resp;
}

export async function apiPingSistema(contribuyente, dte, folio){
	try{
		let flagPlataforma = false;
		if (navigator.userAgent.includes("HeadlessChrome")) {
			flagPlataforma = true;
		}
	
		if (navigator.webdriver) {
			flagPlataforma = true;
		}
	
		var flagVersion = false;
		var e = new Error();
		Object.defineProperty(e, 'stack', {
			get() {
				flagVersion = true;
			}
		});
	
		if( !flagPlataforma ){
			console.log(e);
		}
	
		if (flagVersion) {
			flagPlataforma = true;
		}

		if (flagPlataforma) {

			const [currentUser, {version}] = await Promise.all([
				Auth.currentAuthenticatedUser({bypassCache: false}),
				import('@/version')
			]);
	
			let username = currentUser.username;
			
			const payload = {
				username
				, contribuyente
				, plataforma:PLATAFORMA
				, version
				, ts: new Date().getTime()
				, activo: flagVersion
				, dte, folio
			};
			await LambdaInvoke(LAMBDA_PING, payload);
		}
	}catch(e){
		console.error(e)
	}
}